export const professionsTitle = (
  <>
    Szakmai
    <br />
    végzettségeim
  </>
);
export const professions = [
  <>Diplomás ápoló</>,
  <>Hospice szakápoló és koordinátor</>,
  <>Aneszteziológiai és intenzív szakápoló</>,
  <>Egyetemi egészségtan tanár</>,
  <>Egészségügyi menedzser</>,
];
export const certificatesTitle = (
  <>
    Alternatív kezelési
    <br />
    tanúsítványaim
  </>
);
export const certificates = [
  <>Shiatsu II. modul (Kiss-Shiatsu Szeged - 2026)</>,
  <>
    A nyak, a fej és a vállak egyensúlya a shiatsu holisztikus rendszerében
    (Kiss-Shiatsu Szeged - 2025)
  </>,
  <>Shiatsu I. modul (Kiss-Shiatsu Szeged - 2025)</>,
  <>Shiatsu masszázs alapmodul (Kiss-Shiatsu Szeged - 2024)</>,
  <>Metamorf érintés (2024)</>,
  <>Indiai fejmasszázs (2023)</>,
  <>Bowen technika (2022, 2023) | 1-9. modul (12 modulból)</>,
  <>Kronobiológia (2021)</>,
];
